<template>
  <g>
    <path
      d="M23.3789 20.2931C22.5269 19.4411 21.1454 19.4411 20.2934 20.2931C19.4413 21.1452 19.4413 22.5267 20.2934 23.3787L28.9143 31.9996L20.2934 40.6205C19.4413 41.4726 19.4413 42.8542 20.2934 43.706C21.1454 44.5582 22.5269 44.5582 23.3789 43.706L31.9998 35.0852L40.6207 43.706C41.4727 44.5582 42.8542 44.5582 43.7064 43.706C44.5582 42.8542 44.5582 41.4726 43.7064 40.6205L35.0854 31.9996L43.7064 23.3787C44.5582 22.5267 44.5582 21.1452 43.7064 20.2931C42.8542 19.4411 41.4727 19.4411 40.6207 20.2931L31.9998 28.914L23.3789 20.2931Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.0001 -1.52588e-05C14.3269 -1.52588e-05 0 14.3269 0 32.0001C0 49.6733 14.3269 64 32.0001 64C49.6733 64 64 49.6733 64 32.0001C64 14.3269 49.6733 -1.52588e-05 32.0001 -1.52588e-05ZM4.36364 32.0001C4.36364 16.7369 16.7369 4.36365 32.0001 4.36365C47.2632 4.36365 59.6364 16.7369 59.6364 32.0001C59.6364 47.2632 47.2632 59.6364 32.0001 59.6364C16.7369 59.6364 4.36364 47.2632 4.36364 32.0001Z"
    />
  </g>
</template>
